export default function Logo() {
  return (
    <div className="logo" aria-label="JetShake">
      <img
        className="logo-mark"
        src="/jetshake-mark.svg"
        alt=""
        width={72}
        height={72}
      />
      <span className="logo-wordmark">JetShake</span>
    </div>
  );
}
